

<loading [isLoad]="isLoad"></loading>

<div class="row">
	<div class="col-md-12 padding-bottom">
		<cache-date></cache-date>
	</div>
	
	<div class="col-md-12 padding-bottom">
		<button type="button" class="btn btn-info" (click)="showReportList()">Список выгрузок</button>
	</div>
	
	
	
	<div class="col-md-12 padding-bottom">
		<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>
	</div>
	
	
	<div class="col-md-12 padding-bottom">
		<ngb-accordion #acc="ngbAccordion" [activeIds]="['email']">
			<ngb-panel title="Почтовые фильтры" [id]="'email'">
				<ng-template ngbPanelContent>
					<div class="row">
						<div class="col-md-3">
							Email пользователя
						</div>
						<div class="col-md-9">
							<div class="form-check form-check-inline">
								<input
									class="form-check-input"
									type="checkbox"
									[(ngModel)]="emailKind.userEmailIsConfirm"
									[ngModelOptions]="{standalone: true}"
								/>
								
								<label class="form-check-label">подтвержден</label>
							</div>
						</div>
					</div>
					
					<div class="row">
						<div class="col-md-3">
							Почтовый сервис получателя
						</div>
						
						<div class="col-md-9">
							<div class="form-check form-check-inline" *ngFor="let mail of mailServises">
								<input
									class="form-check-input"
									type="checkbox"
									[(ngModel)]="mail.value"
									[ngModelOptions]="{standalone: true}"
								/>
								
								<label class="form-check-label">
									{{ mail.name }}
								</label>
							</div>
						</div>
					</div>
				</ng-template>
			</ngb-panel>
		</ngb-accordion>
	</div>
	
	<div class="col-md-12 padding-bottom">
		<ngb-accordion #acc="ngbAccordion" [activeIds]="['category']">
			<ngb-panel title="Категория, на которую подписан пользователь" [id]="'category'">
				<ng-template ngbPanelContent>
					<div class="row">
						<div class="col-md-3">
							Подписки
						</div>
						<div class="col-md-9">
							<div class="form-check form-check-inline" *ngFor="let subscription of subscriptions; let i = index">
								<em *ngIf="i > 0" style="margin-right: .75rem;">ИЛИ</em>
								
								<input
									class="form-check-input"
									type="checkbox"
									[(ngModel)]="subscription.value"
									[ngModelOptions]="{standalone: true}"
								/>
								
								<label class="form-check-label">
									{{ subscription.name }}
								</label>
							</div>
						</div>
					</div>
				</ng-template>
			</ngb-panel>
		</ngb-accordion>
	</div>
	
	<div class="col-md-6 padding-bottom">
		<ngb-accordion #acc="ngbAccordion" [activeIds]="['params']">
			<ngb-panel title="Парметры выборки" [id]="'params'">
				<ng-template ngbPanelContent>
					<div class="form-check" *ngFor="let field of fields">
						<input class="form-check-input" type="checkbox" value="" id="defaultCheck1">
						<input
							class="form-check-input"
							type="checkbox"
							[(ngModel)]="field.value"
							[ngModelOptions]="{standalone: true}"
							[disabled]="field.disabled"
						/>
						
						<label class="form-check-label" for="defaultCheck1">
							{{ field.name }}
						</label>
						
						
						
						<div style="padding-left: 36px;" *ngIf="field.name === 'autologin' && field.value">
							<div class="form-group">
								Время жизни автологина (в днях)
								<input
									type="text" class="form-control js-autologin-expire-at"
									[(ngModel)]="autologin.expireAt"
									[ngModelOptions]="{standalone: true}"
								>
							</div>
							
							<div class="form-group">
								<select
									class="form-control"
									[(ngModel)]="autologin.url"
									[ngModelOptions]="{standalone: true}"
								>
									<option value="dashBoard">
										dashBoard
									</option>
									
									<option value="dashBoard/billing/tariffs">
										dashBoard/billing/tariffs
									</option>
									
									<option value="dashBoard/billing/invoices">
										dashBoard/billing/invoices
									</option>
									
									<option value="dashBoard/domains">
										dashBoard/domains
									</option>
									
									<option value="dashBoard/domains/buy/search">
										dashBoard/domains/buy/search
									</option>
									
									<option value="dashBoard/domains/attach">
										dashBoard/domains/attach
									</option>
									
									<option value="dashBoard/bonuses">
										dashBoard/bonuses
									</option>
									
									<option value="pages/id/index/constructor">
										pages/id/index/constructor
									</option>
									
									<option value="pages/id/index/preview">
										pages/id/index/preview
									</option>
									
									<option value="dashBoard/statistics">
										dashBoard/statistics
									</option>
									
									<option value="dashBoard/promo">
										dashBoard/promo
									</option>
									
									<option value="dashBoard/settings">
										dashBoard/settings
									</option>
									
									<option value="dashBoard/webmaster">
										dashBoard/webmaster
									</option>
									
									<option value="dashBoard/placeOnMap">
										dashBoard/placeOnMap
									</option>
									
									<option value="dashBoard/profile">
										dashBoard/profile
									</option>
									
									<option value="dashBoard/badges">
										dashBoard/badges
									</option>
									
									<option value="dashBoard/adv-module/landing">
										dashBoard/adv-module/landing
									</option>
								</select>
							</div>

							<div class="form-group" *ngIf="autologin.url === 'dashBoard/billing/tariffs'">
								<select class="form-control" [(ngModel)]="subUrl" [ngModelOptions]="{standalone: true}">
									<option value="">Тарифные планы</option>
									<option *ngFor="let tariffVariant of tariffVariants" value="{{tariffVariant}}">{{tariffVariant}}</option>
								</select>
							</div>
						</div>
					</div>
				</ng-template>
			</ngb-panel>
		</ngb-accordion>
	</div>
	
	<div class="col-md-6 padding-bottom">
		<button type="button" class="btn btn-success" (click)="addNewReport()">Сформировать выборку</button>
		<button type="button" class="btn btn-link" (click)="clearFilter()">Сбросить фильтры</button>
		<button type="button" class="btn btn-info" (click)="showReportList()">Список выгрузок</button>
	</div>
</div>
